// AUTOGENERATED
import * as $runtime from "../runtime.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Data$dUUID from "../Data.UUID/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Foreign$dNullOrUndefined from "../Foreign.NullOrUndefined/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dCrossSelling from "../Restaumatic.Menu.V2.Types.CrossSelling/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
import * as Unscramble from "../Unscramble/index.js";
const eq = x => y => {
  if (x.tag === "Nothing") { return y.tag === "Nothing"; }
  if (x.tag === "Just") {
    if (y.tag === "Just") { return Restaumatic$dMenu$dV2$dTypes$dCrossSelling.eq2(x._1.items)(y._1.items); }
    return false;
  }
  return false;
};
const eq3 = /* #__PURE__ */ Data$dEq.eqArrayImpl(Data$dEq.eqStringImpl);
const calculatedCrossSellingListIsSymbol = {reflectSymbol: () => "calculatedCrossSellingList"};
const nameIsSymbol = {reflectSymbol: () => "name"};
const onlineOrderingIsSymbol = {reflectSymbol: () => "onlineOrdering"};
const sectionsIsSymbol = {reflectSymbol: () => "sections"};
const MenuIsSymbol = {reflectSymbol: () => "Menu"};
const Menu = x => x;
const newtypeMenu_ = {Coercible0: () => {}};
const hasFieldMenu = dictHasField => dictHasField;
const eqMenu = {
  eq: x => y => eq(x.calculatedCrossSellingList)(y.calculatedCrossSellingList) && x.name === y.name && x.onlineOrdering === y.onlineOrdering && eq3(x.sections)(y.sections)
};
const genericMenu = {to: x => x, from: x => x};
const showMenu = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $0 = Data$dShow.showArrayImpl(Data$dUUID.toString);
      return {
        genericShowArgs: v => [
          (() => {
            if (v.calculatedCrossSellingList.tag === "Just") {
              return "{" + " calculatedCrossSellingList: (Just " + Restaumatic$dMenu$dV2$dTypes$dCrossSelling.showCalculatedCrossSellingList.show(v.calculatedCrossSellingList._1) + ")" + ", name: " + Data$dShow.showStringImpl(v.name) + (v.onlineOrdering
                ? ", onlineOrdering: true, sections: " + $0(v.sections) + " "
                : ", onlineOrdering: false, sections: " + $0(v.sections) + " ") + "}";
            }
            if (v.calculatedCrossSellingList.tag === "Nothing") {
              return "{ calculatedCrossSellingList: Nothing, name: " + Data$dShow.showStringImpl(v.name) + (v.onlineOrdering
                ? ", onlineOrdering: true, sections: " + $0(v.sections) + " "
                : ", onlineOrdering: false, sections: " + $0(v.sections) + " ") + "}";
            }
            $runtime.fail();
          })()
        ]
      };
    })())(MenuIsSymbol);
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeMenu = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons(calculatedCrossSellingListIsSymbol)(Unscramble.decodeMaybe(Restaumatic$dMenu$dV2$dTypes$dCrossSelling.unscrambleDecodeCalculatedCrossSellingList))(Unscramble.decodeRecordCons(nameIsSymbol)(Unscramble.decodeString1)(Unscramble.decodeRecordCons(onlineOrderingIsSymbol)(Unscramble.decodeBoolean1)(Unscramble.decodeRecordCons(sectionsIsSymbol)({
      unsafeDecode: Unscramble.decodeArray(Data$dUUID.udecodeUUID.unsafeDecode)
    })(Unscramble.decodeRecordNil)))).recordInfo(Type$dProxy.Proxy))
  }
))();
const encodeMenu = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericMenu)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor(MenuIsSymbol)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(sectionsIsSymbol)((() => {
      const encode1 = Data$dFunctor.arrayMap(Data$dUUID.encodeUUID.encode);
      return {encodeWithOptions: v => encode1};
    })()))(onlineOrderingIsSymbol)({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce}))(nameIsSymbol)({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce}))(calculatedCrossSellingListIsSymbol)({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return Restaumatic$dMenu$dV2$dTypes$dCrossSelling.encodeCalculatedCrossSellingList.encode(v2._1); }
        $runtime.fail();
      }
    });
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const decodeMenu = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericMenu)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(MenuIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(sectionsIsSymbol)(/* #__PURE__ */ (() => {
    const decode2 = Foreign$dGeneric$dClass.arrayDecode(Data$dUUID.decodeUUID).decode;
    return {decodeWithOptions: v => decode2};
  })())())(onlineOrderingIsSymbol)({decodeWithOptions: v => Foreign$dGeneric$dClass.booleanDecode.decode})())(nameIsSymbol)({
    decodeWithOptions: v => Foreign$dGeneric$dClass.readString
  })())(calculatedCrossSellingListIsSymbol)({
    decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Restaumatic$dMenu$dV2$dTypes$dCrossSelling.decodeCalculatedCrossSellingList.decode)
  })())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
export {
  Menu,
  MenuIsSymbol,
  calculatedCrossSellingListIsSymbol,
  decodeMenu,
  encodeMenu,
  eq,
  eq3,
  eqMenu,
  genericMenu,
  hasFieldMenu,
  nameIsSymbol,
  newtypeMenu_,
  onlineOrderingIsSymbol,
  sectionsIsSymbol,
  showMenu,
  unscrambleDecodeMenu
};
